<template>
  <div class="class-card-widget">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <span class="badge badge-info text-white mr-2 p-1 font-size-12">
          <i class="fe fe-grid"></i> Academic
        </span>
        <h6 class="mb-0 font-weight-bold text-dark">Classes & Sections</h6>
      </div>
      <div class="text-right">
        <span class="font-size-24 font-weight-bold text-info">{{ classCount || 0 }}</span>
        <span class="text-muted font-size-12 ml-1">Classes</span>
      </div>
    </div>

    <div class="row no-gutters text-center border-top pt-2 mt-3">
      <div class="col-6 border-right pr-2">
        <div class="font-size-12 text-muted mb-1"><i class="fe fe-layers mr-1"></i>Sections</div>
        <div class="badge badge-light-info text-info font-weight-bold font-size-14 px-2 py-1">
          {{ sectionCount || 0 }}
        </div>
      </div>
      <div class="col-6 pl-2">
        <div class="font-size-12 text-muted mb-1"><i class="fe fe-folder mr-1"></i>Class Sections</div>
        <div class="badge badge-light-primary text-primary font-weight-bold font-size-14 px-2 py-1">
          {{ classSectionCount || 0 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeoClassCard',
  props: {
    classCount: {
      type: [Number, String],
      default: 0,
    },
    sectionCount: {
      type: [Number, String],
      default: 0,
    },
    classSectionCount: {
      type: [Number, String],
      default: 0,
    },
  },
}
</script>

<style scoped>
.class-card-widget {
  width: 100%;
}
.badge-light-info {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}
.badge-light-primary {
  background-color: #f0f5ff;
  border: 1px solid #adc6ff;
}
</style>
